 document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".tab-btn");
    const productCards = document.querySelectorAll(".product-card-block");
    const newPagination = document.getElementById("new-pagination");
    const metafieldSelect = document.querySelector(".metafields-options");
    const vendorSelect = document.querySelector(".vender-options");
    const filterButton = document.querySelector(".filter-btn");
    const scrollTarget  = document.querySelector('#custom-main-grid');

    // Pagination click handler
    function handlePaginationClick(e) {
      e.preventDefault();
      const url = e.currentTarget.href;
      if (!url) return;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error("Failed to load pagination.");
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const productGrid = doc.querySelector("#product-grid") || doc.querySelector(".product-grid");
          if (productGrid) {
            const currentGrid = document.querySelector("#product-grid");
            if (currentGrid) currentGrid.innerHTML = productGrid.innerHTML;
          }

          const pagination = doc.querySelector(".pagination");
          if (pagination && pagination.innerHTML.trim() !== '') {
            newPagination.innerHTML = pagination.innerHTML;
            newPagination.style.display = "";
           const paginationItems = document.querySelectorAll(".pagination__list li");
            if (scrollTarget) {
              paginationItems.forEach(function (item) {
                item.addEventListener("click", function () {
                  // Add a small delay to allow navigation to new page if applicable
                  setTimeout(() => {
                    scrollTarget.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                });
              });
            }
            bindPaginationEvents();
          } else {
            newPagination.style.display = "none";
          }

          
          const allContainers = document.querySelectorAll(".flex-class-metafields");

  allContainers.forEach(container => {
    // Tabs
    const tabs = container.querySelectorAll(".metafield-tab");
    const blocks = container.querySelectorAll(".metafield-tab-block");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        blocks.forEach(block => block.style.display = "none");
        const targetBlock = blocks[index];
        if (targetBlock) targetBlock.style.display = "flex";

        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");
      });
    });

    // Activate first tab by default
    if (tabs.length > 0) {
      tabs[0].click();
    }

    // Logo selection
    const logoWrappers = container.querySelectorAll(".logo-img-wrapper");
    logoWrappers.forEach(wrapper => {
      wrapper.addEventListener("click", function () {
        logoWrappers.forEach(w => {
          const img = w.querySelector("img");
          if (img) img.classList.remove("active");
        });

        const clickedImg = this.querySelector("img");
        if (clickedImg) clickedImg.classList.add("active");
      });
    });

    // Image selection
    const mainImage = container.querySelector(".main-images");
    const images = container.querySelectorAll(".colors-img");

    images.forEach(image => {
      image.addEventListener("click", () => {
        if (mainImage) {
          mainImage.src = image.src;
        }

        images.forEach(img => img.classList.remove("active"));
        image.classList.add("active");
      });
    });
  });
   const allViewAllWrappers = document.querySelectorAll(".view-all-btn");

  allViewAllWrappers.forEach(function (btnWrapper) {
    const button = btnWrapper.querySelector("button");
    const containermm = btnWrapper.closest(".metafield-tab-block");

    if (containermm && button) {
      const hiddenItems = containermm.querySelectorAll(".color-img-wrapper.hidden-color");
      if (hiddenItems.length > 0) {
        button.addEventListener("click", function () {
          hiddenItems.forEach(function (item) {
            item.style.display = "block";
          });
          btnWrapper.style.display = "none";
        });
      }
    }
  });

document.querySelectorAll('.form-open-btn').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.form-div-block').forEach(formDiv => {
      formDiv.style.display = 'flex';
    });
    document.body.classList.add('form-open-body'); // Add class to body
  });
});

document.querySelectorAll('.close-btn-form').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.form-div-block').forEach(div => {
      div.style.display = 'none';
    });
    document.body.classList.remove('form-open-body'); // Remove class from body
  });
});

        })
        .catch(error => console.error("Pagination error:", error));
    }

    // Bind pagination links
    function bindPaginationEvents() {
      if (!newPagination) return;
      const links = newPagination.querySelectorAll("a");
      links.forEach(link => {
        link.removeEventListener("click", handlePaginationClick);
        link.addEventListener("click", handlePaginationClick);
      });
    }

    // Load collection (no filters)
    function loadCollection(url) {
      if (!url) return;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error("Failed to load collection.");
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const productGrid = doc.querySelector("#product-grid") || doc.querySelector(".product-grid");
          if (productGrid) {
            const currentGrid = document.querySelector("#product-grid");
            if (currentGrid) currentGrid.innerHTML = productGrid.innerHTML;
          }

          const pagination = doc.querySelector(".pagination");
          if (pagination && pagination.innerHTML.trim() !== '') {
            newPagination.innerHTML = pagination.innerHTML;
            newPagination.style.display = "";
                const paginationItems = document.querySelectorAll(".pagination__list li");
          if (scrollTarget) {
            paginationItems.forEach(function (item) {
              item.addEventListener("click", function () {
                // Add a small delay to allow navigation to new page if applicable
                setTimeout(() => {
                  scrollTarget.scrollIntoView({ behavior: "smooth" });
                }, 100);
              });
            });
          }
            bindPaginationEvents();
          } else {
            newPagination.style.display = "none";
          }

          
      const allContainers = document.querySelectorAll(".flex-class-metafields");

  allContainers.forEach(container => {
    // Tabs
    const tabs = container.querySelectorAll(".metafield-tab");
    const blocks = container.querySelectorAll(".metafield-tab-block");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        blocks.forEach(block => block.style.display = "none");
        const targetBlock = blocks[index];
        if (targetBlock) targetBlock.style.display = "flex";

        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");
      });
    });

    // Activate first tab by default
    if (tabs.length > 0) {
      tabs[0].click();
    }

    // Logo selection
    const logoWrappers = container.querySelectorAll(".logo-img-wrapper");
    logoWrappers.forEach(wrapper => {
      wrapper.addEventListener("click", function () {
        logoWrappers.forEach(w => {
          const img = w.querySelector("img");
          if (img) img.classList.remove("active");
        });

        const clickedImg = this.querySelector("img");
        if (clickedImg) clickedImg.classList.add("active");
      });
    });

    // Image selection
    const mainImage = container.querySelector(".main-images");
    const images = container.querySelectorAll(".colors-img");

    images.forEach(image => {
      image.addEventListener("click", () => {
        if (mainImage) {
          mainImage.src = image.src;
        }

        images.forEach(img => img.classList.remove("active"));
        image.classList.add("active");
      });
    });
  });
   const allViewAllWrappers = document.querySelectorAll(".view-all-btn");

  allViewAllWrappers.forEach(function (btnWrapper) {
    const button = btnWrapper.querySelector("button");
    const containermm = btnWrapper.closest(".metafield-tab-block");

    if (containermm && button) {
      const hiddenItems = containermm.querySelectorAll(".color-img-wrapper.hidden-color");
      if (hiddenItems.length > 0) {
        button.addEventListener("click", function () {
          hiddenItems.forEach(function (item) {
            item.style.display = "block";
          });
          btnWrapper.style.display = "none";
        });
      }
    }
  });

document.querySelectorAll('.form-open-btn').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.form-div-block').forEach(formDiv => {
      formDiv.style.display = 'flex';
    });
    document.body.classList.add('form-open-body'); // Add class to body
  });
});

document.querySelectorAll('.close-btn-form').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.form-div-block').forEach(div => {
      div.style.display = 'none';
    });
    document.body.classList.remove('form-open-body'); // Remove class from body
  });
});

        })
        .catch(error => console.error("Collection load error:", error));
    }

    // Load products with filters
    function loadFilteredProducts(forWho, brand) {
      const activeBtn = document.querySelector(".tab-btn.active");
      const baseUrl = activeBtn?.getAttribute("data-collection-title");
      if (!baseUrl) return;

      const queryParams = new URLSearchParams();
      if (forWho) queryParams.append("filter.p.m.custom.for_who_filter", forWho);
      if (brand) queryParams.append("filter.p.vendor", brand);

      const url = `${baseUrl}?${queryParams.toString()}`;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error("Failed to load filtered products.");
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const productGrid = doc.querySelector("#product-grid") || doc.querySelector(".product-grid");
          if (productGrid) {
            const currentGrid = document.querySelector("#product-grid");
            if (currentGrid) currentGrid.innerHTML = productGrid.innerHTML;
          }

          const pagination = doc.querySelector(".pagination");
          if (pagination && pagination.innerHTML.trim() !== '') {
            newPagination.innerHTML = pagination.innerHTML;
            newPagination.style.display = "";
               const paginationItems = document.querySelectorAll(".pagination__list li");
            if (scrollTarget) {
              paginationItems.forEach(function (item) {
                item.addEventListener("click", function () {
                  // Add a small delay to allow navigation to new page if applicable
                  setTimeout(() => {
                    scrollTarget.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                });
              });
            }
            bindPaginationEvents();
          } else {
            newPagination.style.display = "none";
          }
          const allContainers = document.querySelectorAll(".flex-class-metafields");

  allContainers.forEach(container => {
    // Tabs
    const tabs = container.querySelectorAll(".metafield-tab");
    const blocks = container.querySelectorAll(".metafield-tab-block");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        blocks.forEach(block => block.style.display = "none");
        const targetBlock = blocks[index];
        if (targetBlock) targetBlock.style.display = "flex";

        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");
      });
    });

    // Activate first tab by default
    if (tabs.length > 0) {
      tabs[0].click();
    }

    // Logo selection
    const logoWrappers = container.querySelectorAll(".logo-img-wrapper");
    logoWrappers.forEach(wrapper => {
      wrapper.addEventListener("click", function () {
        logoWrappers.forEach(w => {
          const img = w.querySelector("img");
          if (img) img.classList.remove("active");
        });

        const clickedImg = this.querySelector("img");
        if (clickedImg) clickedImg.classList.add("active");
      });
    });

    // Image selection
    const mainImage = container.querySelector(".main-images");
    const images = container.querySelectorAll(".colors-img");

    images.forEach(image => {
      image.addEventListener("click", () => {
        if (mainImage) {
          mainImage.src = image.src;
        }

        images.forEach(img => img.classList.remove("active"));
        image.classList.add("active");
      });
    });
  });
   const allViewAllWrappers = document.querySelectorAll(".view-all-btn");

  allViewAllWrappers.forEach(function (btnWrapper) {
    const button = btnWrapper.querySelector("button");
    const containermm = btnWrapper.closest(".metafield-tab-block");

    if (containermm && button) {
      const hiddenItems = containermm.querySelectorAll(".color-img-wrapper.hidden-color");
      if (hiddenItems.length > 0) {
        button.addEventListener("click", function () {
          hiddenItems.forEach(function (item) {
            item.style.display = "block";
          });
          btnWrapper.style.display = "none";
        });
      }
    }
  });

document.querySelectorAll('.form-open-btn').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.form-div-block').forEach(formDiv => {
      formDiv.style.display = 'flex';
    });
    document.body.classList.add('form-open-body'); // Add class to body
  });
});

document.querySelectorAll('.close-btn-form').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.form-div-block').forEach(div => {
      div.style.display = 'none';
    });
    document.body.classList.remove('form-open-body'); // Remove class from body
  });
});

        })
        .catch(error => console.error("Filter load error:", error));
    }

    // Tab button click logic
    tabButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const tab = btn.getAttribute("data-tab")?.trim();
        const collectionUrl = btn.getAttribute("data-collection-title");

        if (!tab || !collectionUrl) return;

        const metafieldValue = btn.getAttribute("data-metafield-value") || "";
        const vendorValue = btn.getAttribute("data-vendor-value") || "";

        const metafieldValues = [...new Set(metafieldValue.split(',').map(v => v.trim()).filter(v => v))];
        const vendorValues = [...new Set(vendorValue.split(',').map(v => v.trim()).filter(v => v))];

        // Mark tab active
        tabButtons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        // Show matching product cards
        productCards.forEach(card => {
          const cardTab = card.getAttribute("data-tab")?.trim();
          card.style.display = cardTab === tab ? "block" : "none";
        });

        // Populate dropdowns
        if (metafieldSelect) {
          metafieldSelect.innerHTML = '<option value="" disabled selected>For Who</option>';
          metafieldValues.forEach(val => {
            const option = document.createElement("option");
            option.value = val;
            option.textContent = val;
            metafieldSelect.appendChild(option);
          });
          metafieldSelect.value = "";
        }

        if (vendorSelect) {
          vendorSelect.innerHTML = '<option value="" disabled selected>Brand</option>';
          vendorValues.forEach(val => {
            const option = document.createElement("option");
            option.value = val;
            option.textContent = val;
            vendorSelect.appendChild(option);
          });
          vendorSelect.value = "";
        }

        // Load collection via AJAX
        loadCollection(collectionUrl);
      });
    });

    // Auto-trigger first tab
    if (tabButtons.length > 0) {
      tabButtons[0].click();
    }

    // Apply filter button
    if (filterButton) {
      filterButton.addEventListener("click", function () {
        const selectedForWho = metafieldSelect?.value || "";
        const selectedBrand = vendorSelect?.value || "";
        loadFilteredProducts(selectedForWho, selectedBrand);
      });
    }

    // Reload on browser back/forward
    window.addEventListener('popstate', function () {
      location.reload();
    });
  });